import { EXPLORE_SCHEMES_USER_FLOW } from '../../../constants/ExplorePage';
import GTM, { getGtmData } from '../../../GTM';
import { SchemeDetail } from '../../../pages/explore/detail/[fundCode]';
import High from '../../../assets/icons/riskometer/High.svg';
import V_High from '../../../assets/icons/riskometer/V_High.svg';
import Low from '../../../assets/icons/riskometer/Low.svg';
import M_High from '../../../assets/icons/riskometer/M_High.svg';
import M_Low from '../../../assets/icons/riskometer/M_Low.svg';
import Moderate from '../../../assets/icons/riskometer/Moderate.svg';

export const getRiskProfileSvg = (risk: string) => {
  switch (risk) {
    case 'Moderately High':
      return <M_High />;
    case 'High':
      return <High />;
    case 'Very High':
      return <V_High />;
    case 'Low':
      return <Low />;
    case 'Moderate':
      return <Moderate />;
    case 'Moderately Low':
      return <M_Low />;
    default:
      return <Low />;
  }
};

export const getAMCImage = (amc) => {
  switch (amc) {
    case 'AXIS':
      return 'axis-mf.svg';
    case 'BIRLA':
      return 'birla-logo.png';
    case 'CANARA':
      return 'CanaraRobeco-logo.svg';
    case 'DSP':
      return 'dspmf-cmyk.svg';
    case 'EDELWEISS':
      // return 'edelweiss-amc-blue.svg';
      return 'edelweiss.png';
    case 'FRANKLIN':
      // return 'franklin.jpg';
      return 'franklintemp.png';
    case 'HDFC':
      return 'hdfc-amc.jpg';
    case 'HSBC':
      return 'hsbc.png';
    case 'ICICI':
      return 'icici-amc.svg';
    case 'IDFC':
    case 'BANDHAN':
      //return 'idfc-asset-management.svg';
      return 'bandhan-amc.png';
    case 'KOTAK':
      return 'kotak-mf-white.svg';
    case 'LICNOMURA':
      return 'lic-mf.svg';
    case 'LNT':
      return 'L&T-MF.svg';
    case 'MIRAE':
      return 'mirae-asset-mutual-fund.png';
    case 'MOTILAL':
      return 'motilal-oswal.svg';
    case 'NipponIndia':
      // return 'nippon-india-mf.png';
      return 'nippon.png';
    case 'PRINCIPAL':
      return 'principal.png';
    case 'RELIANCE':
      // return 'nippon-india-mf.png';
      return 'nippon.png';
    case 'RELIGARE':
      return 'invesco-logo.svg';
    case 'SBI':
      // return 'sbi-mutual-fund.jpg';
      return 'sbi.png';
    case 'SUNDARAMK':
      return 'sundaram-amc.svg';
    case 'TATA':
      return 'tata-mutual-fund.png';
    case 'UTI':
      return 'uti-logo.svg';
    case 'BAJAJ':
      return 'bajaj-logo.png';
    case 'YES':
      return 'whiteoak-mf-logo.png';
    case 'IIFL':
      return 'Logo-Left.png';
    case 'UNIONKBC':
      return 'Union mutual fund-01.jpg';
    case 'MAHINDRA':
      return 'Mahindra Manulife Mutual Fund Logo.svg';
    case 'PPFAS':
      return 'ppfas-logo.svg';
    case 'BNPK':
      return 'bnpk-amc.jpg';
    default:
      return 'amc.svg';
  }
};

// To replace all the occurrence of a character with the specified character in the text.
// Finds all the occurrence of "characterToRemove" in the string "text" and replace them with "characterToReplace"
export const replaceAllOccurenceOfCharacter = (text: string, characterToRemove: string, characterToReplace) => {
  return text.replaceAll(characterToRemove, characterToReplace);
};

// To extract fundType i.e Large cap, Mid cap, Small cap, etc.
// original string i.e schemeClass will be kind of "EQUITY:Multi Cap Fund" and this util will return "Multi Cap Fund"
export const getSchemeTypeFromSchemeClass = (schemeClass: string) => {
  return schemeClass?.substring(schemeClass.indexOf(':') + 1);
};

export const triggerGtmOnPageLoadEventSchemeDetailsPage = (
  userFlow: string,
  schemeDetails: SchemeDetail,
  invIdeaScheme: string
) => {
  switch (userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.explore.schemeDetailPageLoad(schemeDetails?.schemeName);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.schemeDetailPageLoad(schemeDetails?.schemeName);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.schemeDetailPageLoad(schemeDetails?.schemeName, invIdeaScheme);
      break;
  }
};

// actionType will be either Back or Click here
export const triggerGtmActionClickSchemeDetailsPage = (
  userFlow: string,
  schemeDetails: SchemeDetail,
  actionType: string,
  invIdeaScheme: string
) => {
  switch (userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.explore.schemeListActionClick(schemeDetails?.schemeName, actionType);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.schemeListActionClick(schemeDetails?.schemeName, actionType);
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.schemeListActionClick(schemeDetails?.schemeName, invIdeaScheme, actionType);
      break;
  }
};

export const triggerGtmOnInvestClickSchemeDetailsPage = (
  userFlow: string,
  schemeDetails: SchemeDetail,
  invIdeaScheme: string
) => {
  switch (userFlow) {
    case EXPLORE_SCHEMES_USER_FLOW.EXPLORE:
    case EXPLORE_SCHEMES_USER_FLOW.PLAN_GOALS_WITH_SIP:
      GTM.explore.schemeListInvestClick(
        schemeDetails?.schemeName,
        {
          cd66: getGtmData('cd66'),
          cd68: getGtmData('cd68'),
        },
        userFlow
      );
      break;
    case EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX:
      GTM.saveTax.schemeListInvestClick(
        schemeDetails?.schemeName,
        {
          cd66: getGtmData('cd66'),
          cd68: getGtmData('cd68'),
        },
        userFlow
      );
      break;
    case EXPLORE_SCHEMES_USER_FLOW.INVESTMENT_IDEAS:
      GTM.investmentIdeas.schemeListInvestClick(
        schemeDetails?.schemeName,
        invIdeaScheme,
        {
          cd66: getGtmData('cd66'),
          cd68: getGtmData('cd68'),
        },
        userFlow
      );
      break;
  }
};

export const textAnchorPosition = (index, chartLength) => {
  if (index > chartLength * 0.1) {
    return 'end';
  } else if (index > chartLength * 0.9) {
    return 'end';
  } else {
    return 'middle';
  }
};
